import { positionOptions, posLabel } from './crewPositions';

export function CrewPositionSelect({ member, value, onChange, training, cabinSlots, trainingReason, onTrainingChange }) {
    const isCabin = member.position === 'flight_attendant';
    const opts = [...positionOptions(member.position, training, cabinSlots), ...(isCabin ? ['TCP_ADD'] : [])];
    if (!opts.length) {
        return <span className="text-[11px] text-red-700 dark:text-red-400" data-testid={`crew-pos-none-${member.id}`}>Sin posición</span>;
    }
    const inTraining = trainingReason !== undefined && trainingReason !== null && trainingReason !== false;
    return (
        <div className="flex flex-col items-end gap-1">
            <label className="flex items-center gap-1.5">
                <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">Posición</span>
                <select value={value || ''} onChange={e => onChange(e.target.value || null)}
                    className="h-7 rounded-md border border-input bg-background px-2 text-xs font-mono" data-testid={`crew-pos-${member.id}`}>
                    {isCabin && <option value="">Automática</option>}
                    {opts.map(p => <option key={p} value={p}>{posLabel(p)}</option>)}
                </select>
            </label>
            {isCabin && (
                <label className="flex items-center gap-1.5 text-[11px]">
                    <input type="checkbox" checked={inTraining} onChange={e => onTrainingChange(e.target.checked ? '' : false)} data-testid={`crew-training-${member.id}`} />
                    En instrucción
                </label>
            )}
            {isCabin && inTraining && (
                <input value={trainingReason} onChange={e => onTrainingChange(e.target.value)} placeholder="Motivo (mín. 10 caracteres)"
                    className="h-7 w-56 rounded-md border border-input bg-background px-2 text-xs" data-testid={`crew-training-reason-${member.id}`} />
            )}
        </div>
    );
}
